export default __webpack_public_path__ + "static/Offering-Our-Best-To-The-World-For-A-Brighter-Tomorrow-63af9d77b69b7d854306f1f14b58abca.webp";